export default __webpack_public_path__ + "static/media/tool_item_1.5aadfed7.png";